import React from 'react';
import { HandshakeIcon, EyeIcon, DollarSignIcon, ClockIcon } from 'lucide-react';
export function HowWeWork() {
  return <div className="w-full bg-black py-24 relative overflow-hidden" data-id="element-346">
      <div className="absolute inset-0 opacity-5 animate-scanline" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #00ff00 2px, #00ff00 4px)'
    }} data-id="element-347" />
      {/* Floating particles */}
      {[...Array(20)].map((_, i) => <div key={i} className="absolute w-1 h-1 rounded-full animate-float" style={{
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      backgroundColor: i % 2 === 0 ? '#22c55e' : '#f59e0b',
      animationDelay: `${Math.random() * 5}s`,
      animationDuration: `${8 + Math.random() * 12}s`,
      opacity: 0.3
    }} data-id="element-348" />)}
      <div className="container mx-auto px-6 relative z-10" data-id="element-349">
        <div className="max-w-5xl mx-auto" data-id="element-350">
          {/* Header */}
          <div className="mb-16 animate-fade-in-up" data-id="element-351">
            <div className="inline-block border-4 border-green-500 bg-black px-6 py-3 mb-6 shadow-[0_0_30px_rgba(0,255,0,0.4)] animate-glow-green" data-id="element-352">
              <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono" data-id="element-353">
                HOW WE WORK
              </h2>
            </div>
            <p className="text-amber-500 text-xl font-mono mb-4 animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }} data-id="element-354">
              // PARTNERSHIP MODEL, NOT VENDOR RELATIONSHIP
            </p>
          </div>
          {/* Main principles */}
          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-355">
            <div className="border-4 border-amber-600 bg-zinc-950 p-8 animate-fade-in-up hover:scale-[1.02] transition-all duration-500 group relative overflow-hidden" style={{
            animationDelay: '0.3s'
          }} data-id="element-356">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-950/0 via-amber-950/20 to-amber-950/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-357" />
              <div className="absolute top-0 right-0 w-20 h-20 border-t-2 border-r-2 border-amber-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-358" />
              <div className="border-2 border-amber-500 bg-amber-950 w-16 h-16 flex items-center justify-center mb-6 group-hover:rotate-12 group-hover:scale-110 transition-all duration-500 relative z-10" data-id="element-359">
                <HandshakeIcon className="w-8 h-8 text-amber-500 animate-pulse" data-id="element-360" />
              </div>
              <h3 className="text-2xl font-bold text-amber-500 mb-4 font-mono relative z-10 group-hover:text-glow transition-all duration-300" data-id="element-361">
                PARTNERS, NOT VENDORS
              </h3>
              <p className="text-amber-100 leading-relaxed mb-4 relative z-10" data-id="element-362">
                We're not here to take orders and deliver features. We're here
                to challenge your assumptions, push back on bad ideas, and build
                systems that actually move profit.
              </p>
              <p className="text-amber-100 leading-relaxed relative z-10" data-id="element-363">
                That means uncomfortable conversations. It means saying "no"
                when you ask for something that won't work. It means being
                honest about timelines, costs, and trade-offs.
              </p>
            </div>
            <div className="border-4 border-green-500 bg-zinc-950 p-8 animate-fade-in-up hover:scale-[1.02] transition-all duration-500 group relative overflow-hidden" style={{
            animationDelay: '0.4s'
          }} data-id="element-364">
              <div className="absolute inset-0 bg-gradient-to-br from-green-950/0 via-green-950/20 to-green-950/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-365" />
              <div className="absolute top-0 right-0 w-20 h-20 border-t-2 border-r-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-366" />
              <div className="border-2 border-green-500 bg-green-950 w-16 h-16 flex items-center justify-center mb-6 group-hover:rotate-12 group-hover:scale-110 transition-all duration-500 relative z-10" data-id="element-367">
                <EyeIcon className="w-8 h-8 text-green-400 animate-pulse" data-id="element-368" />
              </div>
              <h3 className="text-2xl font-bold text-green-400 mb-4 font-mono relative z-10 group-hover:text-glow transition-all duration-300" data-id="element-369">
                RADICAL TRANSPARENCY
              </h3>
              <p className="text-amber-100 leading-relaxed mb-4 relative z-10" data-id="element-370">
                You see everything. Code, decisions, reasoning, trade-offs. We
                share our thinking process, not just the final deliverable.
              </p>
              <p className="text-amber-100 leading-relaxed relative z-10" data-id="element-371">
                The goal isn't just happy users—it's capable partners who
                understand why we built what we built. Teaching through the
                work.
              </p>
            </div>
          </div>
          {/* Pricing model */}
          <div className="border-4 border-amber-600 bg-black p-10 mb-12 animate-fade-in-up relative overflow-hidden group" style={{
          animationDelay: '0.5s'
        }} data-id="element-372">
            <div className="absolute inset-0 opacity-10 animate-pulse-slow" data-id="element-373">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-amber-500 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-2000" data-id="element-374" />
            </div>
            <div className="flex items-start gap-6 mb-8 relative z-10" data-id="element-375">
              <div className="border-2 border-amber-500 bg-amber-950 w-20 h-20 flex items-center justify-center flex-shrink-0 group-hover:scale-110 group-hover:rotate-12 transition-all duration-500" data-id="element-376">
                <DollarSignIcon className="w-10 h-10 text-amber-500 animate-pulse" data-id="element-377" />
              </div>
              <div data-id="element-378">
                <h3 className="text-3xl font-bold text-amber-500 mb-4 font-mono group-hover:text-glow transition-all duration-300" data-id="element-379">
                  OUTCOME-BASED PRICING
                </h3>
                <p className="text-amber-100 text-lg leading-relaxed" data-id="element-380">
                  We don't charge by the hour. We charge based on the value we
                  create. If we can't articulate a clear ROI, we don't take the
                  project.
                </p>
              </div>
            </div>
            <div className="border-l-4 border-green-500 pl-6 py-4 bg-green-950/20 space-y-4 relative z-10 hover:bg-green-950/30 transition-colors duration-300" data-id="element-381">
              {[{
              title: 'FIXED_SCOPE_PROJECTS:',
              desc: "Clear deliverable, clear timeline, clear price. You know exactly what you're getting and what it costs."
            }, {
              title: 'PROFIT_SHARE_ARRANGEMENTS:',
              desc: "For the right projects, we'll tie our compensation to your results. If you don't profit, we don't profit."
            }, {
              title: 'LONG_TERM_RETAINERS:',
              desc: 'For ongoing AI automation implementations and strategic partnerships, we offer retainer arrangements focused on continuous optimization and long-term value creation.'
            }].map((item, i) => <div key={i} className="group/item hover:translate-x-2 transition-transform duration-300" data-id="element-382">
                  <p className="text-green-400 font-mono text-sm mb-2 flex items-center gap-2" data-id="element-383">
                    <span className="w-2 h-2 bg-green-400 animate-pulse" data-id="element-384" />
                    {'>'} {item.title}
                  </p>
                  <p className="text-amber-100" data-id="element-385">{item.desc}</p>
                </div>)}
            </div>
          </div>
          {/* Timeline */}
          <div className="border-4 border-green-500 bg-zinc-950 p-10 animate-fade-in-up relative overflow-hidden group" style={{
          animationDelay: '0.6s'
        }} data-id="element-386">
            <div className="absolute inset-0 opacity-10 animate-pulse-slow" data-id="element-387">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-500 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-2000" data-id="element-388" />
            </div>
            <div className="flex items-start gap-6 mb-8 relative z-10" data-id="element-389">
              <div className="border-2 border-green-500 bg-green-950 w-20 h-20 flex items-center justify-center flex-shrink-0 group-hover:scale-110 group-hover:rotate-12 transition-all duration-500" data-id="element-390">
                <ClockIcon className="w-10 h-10 text-green-400 animate-pulse" data-id="element-391" />
              </div>
              <div data-id="element-392">
                <h3 className="text-3xl font-bold text-green-400 mb-4 font-mono group-hover:text-glow transition-all duration-300" data-id="element-393">
                  PHYSICS-SPEED DELIVERY
                </h3>
                <p className="text-amber-100 text-lg leading-relaxed" data-id="element-394">
                  We set deadlines based on what's physically possible, not
                  "industry standard" or "how we've always done it."
                </p>
              </div>
            </div>
            <div className="space-y-6 relative z-10" data-id="element-395">
              {[{
              week: 'WEEK 1',
              desc: 'Challenge requirements, delete waste, map the simplified process. Working prototype by end of week.',
              color: 'amber'
            }, {
              week: 'WEEK 2',
              desc: 'Real users testing in real scenarios. Fast feedback loops. Course corrections based on actual usage, not assumptions.',
              color: 'green'
            }, {
              week: 'WEEK 3',
              desc: 'Measuring results. Did we move the profit needle? If not, we iterate. If yes, we document and hand off.',
              color: 'amber'
            }].map((item, i) => <div key={i} className="flex items-start gap-4 group/week hover:translate-x-4 transition-transform duration-300" data-id="element-396">
                  <div className={`text-2xl font-bold ${item.color === 'amber' ? 'text-amber-500' : 'text-green-400'} font-mono w-20 flex-shrink-0 animate-pulse`} style={{
                animationDelay: `${i * 0.2}s`
              }} data-id="element-397">
                    {item.week}
                  </div>
                  <div className="flex-grow" data-id="element-398">
                    <div className={`h-1 w-0 group-hover/week:w-full ${item.color === 'amber' ? 'bg-amber-500' : 'bg-green-400'} transition-all duration-500 mb-2`} data-id="element-399" />
                    <p className="text-amber-100" data-id="element-400">{item.desc}</p>
                  </div>
                </div>)}
            </div>
            <div className="mt-8 border-t-2 border-green-500 pt-6 relative z-10" data-id="element-401">
              <p className="text-amber-100 leading-relaxed" data-id="element-402">
                <span className="text-green-400 font-semibold" data-id="element-403">
                  Compare that to typical projects:
                </span>{' '}
                6 months of meetings, documentation, and planning before anyone
                sees anything. Then it launches and nobody uses it because
                requirements changed 4 months ago.
              </p>
            </div>
          </div>
        </div>
      </div>
      <style data-id="element-404">{`
        @keyframes scanline {
          0% { transform: translateY(0); }
          100% { transform: translateY(100vh); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(-100px) translateX(50px); }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes glow-green {
          0%, 100% { box-shadow: 0 0 30px rgba(0, 255, 0, 0.4); }
          50% { box-shadow: 0 0 50px rgba(0, 255, 0, 0.7); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.1; }
          50% { opacity: 0.2; }
        }
        .animate-scanline {
          animation: scanline 8s linear infinite;
        }
        .animate-float {
          animation: float linear infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-glow-green {
          animation: glow-green 3s ease-in-out infinite;
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
        .text-glow {
          text-shadow: 0 0 20px currentColor;
        }
        .transition-transform.duration-2000 {
          transition-duration: 2000ms;
        }
      `}</style>
    </div>;
}